import React from "react";
import PropTypes from "prop-types";
import {
  getTaskPriorityColors,
  getTaskPriorityLabel,
} from "../../../utils/taskPriority";
import "./TaskPriorityChip.css";

/**
 * Color-coded priority pill for task tables and detail views.
 */
export function TaskPriorityChip({ priority, className }) {
  const { backgroundColor, color } = getTaskPriorityColors(priority);
  const label = getTaskPriorityLabel(priority);

  return (
    <span
      className={["task-priority-chip", className].filter(Boolean).join(" ")}
      style={{ backgroundColor, color }}
    >
      {label}
    </span>
  );
}

TaskPriorityChip.propTypes = {
  priority: PropTypes.string,
  className: PropTypes.string,
};

export default TaskPriorityChip;
